module.exports = __webpack_public_path__ + "static/media/Montrose_transparent.71cfe51b.png";